import React from 'react';
import {Box, Table, Thead, Tbody, Tr, Td, useBreakpointValue} from '@chakra-ui/react';

const ReportTable = ({tableData}) => {
    const isMobile = useBreakpointValue({base: true, md: false});

    const renderTableRows = () => {
        return tableData.rows.sections.map((section, index) => (
            <React.Fragment key={index}>
                {section.rowColumns.map((rowColumn, rowIndex) => (
                    <Tr key={rowIndex} bg={section.id % 2 === 0 ?  "inherit" : "#F7F7F7" }>
                        {rowColumn.columns.map((column, columnIndex) => (
                            <Td key={columnIndex}
                                style={{ 
                                    width: isMobile ? (columnIndex === 0 ? '50%' : '25%') : (columnIndex === 0 ? '70%' : '15%'),
                                    textAlign: columnIndex > 0 ? 'right' : 'left' 
                                }}
                                fontWeight={column.isHighlighted === 'true' ? 'bold' : 'normal'}>
                                {column.value}
                            </Td>
                        ))}
                    </Tr>
                ))}
            </React.Fragment>
        ));
    };

    return (
        <Box>
            <Table borderBottom="2px solid #C9CED1" variant="unstyled" colorScheme="gray">
                <Thead>
                    <Tr>
                        {tableData.columnTitles.map((title, index) => {
                            const [firstLine, secondLine] = title.split('\n');
                            const hasSecondLine = secondLine !== undefined;
                            return (<Td style={{ 
                                width: index === 0 ? '70%' : '15%',
                                textAlign: index > 0 ? 'right' : 'left' // Align text right for columns 1 and 2
                            }} key={index} fontWeight={'bold'}>{firstLine} {hasSecondLine && <br/>} {secondLine}</Td>);
                        })}
                    </Tr>
                </Thead>
                <Tbody>{renderTableRows()}</Tbody>
            </Table>
        </Box>
    );
};

export default ReportTable;